import Skeleton from "@mui/material/Skeleton";

const TableSkeletonRows = ({ rows = 3, columns = 7 }) => {
	return [...Array(rows)].map((_, idx) => (
		<tr key={idx}>
			{[...Array(columns)].map((__, colIdx) => (
				<td key={colIdx}><Skeleton /></td>
			))}
		</tr>
	));
};

export default TableSkeletonRows;
